module.exports = __webpack_public_path__ + "media/images/emblems/Kleinandelfingen-blazon-da4b6a153233c729365d1a3991776c14.svg";